import React from 'react';
import { Box, Typography } from '@material-ui/core';
import clsx from 'clsx';
import useStyles from './style';

interface Props {
  text: string;
  maxLength: number;
}

const TextFieldLength: React.FC<Props> = (props) => {
  const { text, maxLength } = props;
  const classes = useStyles();

  return (
    <Box className={classes.textLengthContainer}>
      <Typography
        variant='body2'
        className={clsx({
          [classes.maxTextLength]: text === '',
          [classes.currentTextLength]: text !== '',
        })}
      >
        {text.length}
      </Typography>
      <Typography variant='body2' className={classes.maxTextLength}>
        {`/${maxLength}`}
      </Typography>
    </Box>
  );
};

export default TextFieldLength;
